import React from 'react';
import Featured from '../Featured';
import './styles.scss';

function DrColum2() {
  return (
  <div className='container'>
<div className="column2" id="column2">

<div className="intern-nav" id="intern">

    <li className="each-nav-item right-pad">
        <a class="nav-link active">
            Featured
        </a>
    </li>

    <li className="each-nav-item center-pad">
        <a class="nav-link">
            On Sale
        </a>
    </li>

    <li className="each-nav-item left-pad">
        <a class="nav-link">
            Top Rated
        </a>
    </li>

</div>

<div className="nav-content-container">
    <Featured />
</div>
</div>
  </div>
  );
}

export default DrColum2;
